
import { common as enCommon } from './en/common';
import { common as koCommon } from './ko/common';
import { common as esCommon } from './es/common';

export const resources = {
  en: {
    common: enCommon
  },
  ko: {
    common: koCommon
  },
  es: {
    common: esCommon
  }
};
